import { useMutation } from '@tanstack/react-query';

import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postRestoreUser } from '../../requests/postRestoreUser';

export const useRestoreUser = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: restoreUser, ...rest } = useMutation({
    mutationFn: (uuid: string) => postRestoreUser(constructPost, uuid),
    onSuccess: () => handleSuccess('User restored.'),
    onError: () => handleError('Failed to restore user.'),
  });

  return { restoreUser, ...rest };
};
